export default "__VITE_ASSET__148896da__"